<template>
  <div class="homework">
    <div class="clearfix title">
      <span class="one">我发布的学习任务</span>

      <span
        class="tab"
        v-for="(n, i) in listdata"
        :key="i"
        @click="getswitch(n, i)"
        :class="{ current: ddindex == i }"
        >{{ n }}</span
      >
      <span
        class="fr"
        @click="$router.push('/homework')"
        style="cursor: pointer"
        >更多 ></span
      >
    </div>
    <div v-if="list.length">
      <div class="taskbox" v-if="isShow">
        <div
          v-for="(item, index) in list"
          :key="index"
          class="task"
          @click="handeltails(item, index)"
        >
          <p style="font-size: 14px; text-align: center" class="ppp">
            <!-- 作业/任务 -->
            {{ item.storage == 1 ? "题库作业" : "课外作业" }}
            <!-- 课后复习 -->
          </p>
          <div
            style="font-size: 20px; text-align: center;margin:15px; 0;height: 26px;
    overflow: hidden"
          >
            {{ item.title }}
          </div>
          <div class="clearfix" style="padding: 0 20px">
            <span class="fr"
              >{{ item.did_num }}<span>/{{ item.student_num }}</span></span
            >
            <span class="fl">
              <!-- <span> -->
              <!-- {{ item.class_info && item.class_info.grade_id }} 年级 -->
              <!-- </span> -->
              {{ grade_name
              }}{{ item.class_info && item.class_info.class_name }}</span
            >
            <!-- <span>{{classname}}</span> -->
          </div>
        </div>
      </div>
      <div class="taskbox" v-else>
        <div
          v-for="(item, index) in list"
          :key="index"
          class="task"
          @click="handeltask(item, index)"
          :class="item.type == '2' ? 'task22' : 'task33'"
        >
          <p
            style="font-size: 14px; text-align: center"
            class="ppp"
            :class="item.type == '2' ? 'ppp2' : 'ppp3'"
          >
            <!-- 作业/任务 -->
            {{ item.type == "2" ? "课后复习" : "课前预习" }}
            <!-- 课后复习 -->
          </p>
          <div
            style="font-size: 20px; text-align: center;margin:15px; 0;height: 26px;
    overflow: hidden"
          >
            {{ item.title }}
          </div>
          <div class="clearfix" style="padding: 0 20px">
            <span class="fr"
              >{{ item.finish_info && item.finish_info.finish_num
              }}<span
                >/{{ item.finish_info && item.finish_info.student_num }}</span
              ></span
            >
            <span class="fl">
              <!-- <span
                >{{ item.class_info && item.class_info.grade_id }} 年级
              </span> -->
              {{ grade_name
              }}{{ item.class_info && item.class_info.class_name }}</span
            >
            <!-- <span>{{classname}}</span> -->
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div style="text-align: center; padding: 20px 0">暂无数据..</div>
    </div>
  </div>
</template>

<script>
import eventBus from "../../api/eventBus";
import URL from "@/api/index.js";
export default {
  data() {
    return {
      activeName: "second",
      listdata: ["作业", "预习", "复习"],
      list: [],
      isShow: true,
      ddindex: 0,
      token: "",
      classid: "",
      classname: "",
      classdata: [],
      grade_name: null,
      // class_info: {},
      // finish_info: {},
    };
  },
  components: {},
  created() {
    this.token = JSON.parse(localStorage.getItem("loginInfo")).token;
  },
  beforeMount() {},
  mounted() {
    this.classid = JSON.parse(localStorage.getItem("loginInfo")).class_id;
    if (JSON.parse(localStorage.getItem("classdata"))) {
      this.classdata = JSON.parse(localStorage.getItem("classdata"));
    }
    this.gethomework();
    // eventBus.$on("classdata", (res) => {
    //   console.log(res);
    //   this.classdata=res
    //   res.forEach((item) => {
    //     if (item.class_id == this.classid) {
    //       this.classname = `${item.grade_name}${item.class_name}`;
    //     }
    //   });
    // });
    eventBus.$on("classChange", (res) => {
      this.classid = res;
      this.gethomework();
    });
  },
  methods: {
    // 作业
    gethomework() {
      var data = { token: this.token, class_id: this.classid };
      this.$post(URL.getHomework, data).then((res) => {
        if (this.classdata) {
          this.classdata.forEach((item) => {
            if (this.classid == item.class_id) {
              this.grade_name = item.grade_name;
            }
          });
        }
        if (res.result.length != 0) {
          if (res.result.lists && res.result.lists.length) {
            // console.log(111111111111);
            this.list = res.result.lists.slice(0, 9);
            this.list.forEach((item) => {
              item.one = "作业";
              this.class_info = item.class_info;
            });
          }
        }
      });
    },
    gethometask(n) {
      var data = { token: this.token, type: n, class_id: this.classid };
      this.$post(URL.getHometask, data).then((res) => {
        console.log(res.result)
        if (res.state == 0) {
          this.list = res.result.slice(0, 9);
          this.list.forEach((item) => {
            if (n == 1) {
              item.one = "预习";
            } else {
              item.one = "复习";
            }

            // this.class_info = item.class_info;
            // this.finish_info = item.finish_info;
          });
        }
      });
    },
    handeltails(val, index) {
      // console.log(val,index)
      if (val.storage == 1) {
        this.$router.push({
          name: "workcheck",
          query: {
            assid: val.assign_id,
            examid: val.exam_id,
          },
        });
      } else {
        this.$router.push({
          name: "customwork",
          query: {
            assid: val.assign_id,
            examid: val.exam_id,
          },
        });
      }
    },
    handeltask(val, index) {
      this.$router.push({
        name: "taskcheck",
        query: {
          assid: val.assign_id,
          taskid: val.task_id,
          finish: val.finish_num,
          student: val.student_num,
        },
      });
    },
    getswitch(n, i) {
      this.ddindex = i;
      if (i == 0) {
        this.gethomework();
        this.isShow = true;
      }
      if (i == 2) {
        //复习
        this.gethometask(2);
        this.isShow = false;
      }
      if (i == 1) {
        //预习
        this.isShow = false;
        this.gethometask(1);
      }
    },
  },
};
</script>

<style lang='less' scoped>
.homework {
  width: 770px;
  margin-top: 15px;
  background-color: #fff;
  border-radius: 8px;
  padding: 10px 30px;
  .one {
    font-size: 18px;
    margin-right: 30px;
    border-left: 4px solid #409eff;
    padding-left: 20px;
  }
  .title {
    padding-bottom: 10px;
    border-bottom: 1px solid #f4f4f4;
    margin-bottom: 10px;
  }
  .tab {
    margin-right: 30px;
    background-color: #fff;
    padding: 10px 24px 12px 24px;
    border-radius: 8px 8px 0 0;
    cursor: pointer;
  }
  .tab:hover {
    color: #fff;
    background-color: #409eff;
  }
  .current {
    color: #fff;
    background-color: #409eff;
  }

  .task {
    cursor: pointer;
    display: inline-block;
    background-image: url("../../assets/task1.png");
    color: #fff;
    width: 31%;
    margin: 10px 8px;
    border-radius: 8px;
    .ppp {
      color: #22b258;
    }
  }
  .task:hover {
    background-image: url("../../assets/task11.png");
  }
  .task22 {
    background-image: url("../../assets/task2.png");

    .ppp2 {
      color: #ff7618;
    }
  }
  .task22:hover {
    background-image: url("../../assets/task22.png");
  }
  .task33 {
    background-image: url("../../assets/task3.png");

    .ppp3 {
      color: #3a9bfe;
    }
  }
  .task33:hover {
    background-image: url("../../assets/task33.png");
  }
}
</style>
